<div class="control-card-header">
    <div id="header">
        <ng-container i18n="@@insert_user_insert_user_header">Inserimento abbonamento</ng-container>
        <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeDialog()"></fa-icon>
    </div>
</div>

<div class="control-card-content">

    <form [formGroup]="joinForm">
        <table class="simple-table user-add-table">
            <tr>
                <td width="180px" class="text-dark" i18n="@@insert_user_first_name">Nome</td>
                <td>
                    <input id="first-name-input" formControlName="firstname" [(ngModel)]="firstname" />
                </td>
            </tr>

            <tr>
                <td width="180px" class="text-dark" i18n="@@insert_user_last_name">Cognome</td>
                <td>
                    <input id="last-name-input" formControlName="lastname" [(ngModel)]="lastname" />
                </td>
            </tr>


            <tr>
                <td width="180px" height="80px" class="text-dark" i18n="@@insert_user_email">Email</td>
                <td>
                    <input id="email-input" formControlName="email" [(ngModel)]="email" />
                </td>
            </tr>


            <tr>
                <td width="180px" height="80px" class="text-dark" i18n="@@insert_user_licensePlate">Targa</td>
                <td>
                    <input id="licensePlate-input" formControlName="licensePlate" [(ngModel)]="licensePlate" />
                </td>
            </tr>

            <tr>
                <td width="180px" height="80px" class="text-dark" i18n="@@insert_user_phoneNumber">Numero di telefono
                </td>
                <td>
                    <select formControlName="prefix" style="width: 25%;" [(ngModel)]="prefix">
                        <option *ngFor="let prefix of prefixes" [value]="prefix.value">
                            {{prefix.text}}
                        </option>
                    </select>
                    <input formControlName="phoneNumber" type="text" style="width: 75%;" [(ngModel)]="phoneNumber" />
                </td>

            </tr>

            <tr>
                <td width="180px" class="text-dark" i18n="@@insert_user_file">
                    Carica file (opzionale)
                </td>
                <td>
                    <ng-container i18n="@@insert_user_file_ci">Documento di identità</ng-container><br>
                    <input type="file" accept=".jpg,.jpeg,.png,.bmp,.pdf,.doc,.docx"
                        (change)="onFileCiSelected($event)"><br><br>

                    <ng-container i18n="@@insert_user_file_room">Documentazione stanze e/o
                        appartamenti</ng-container><br>
                    <input type="file" accept=".jpg,.jpeg,.png,.bmp,.pdf,.doc,.docx"
                        (change)="onFileRoomSelected($event)"><br><br>

                    <ng-container i18n="@@insert_user_file_cir">Codice Identificativo di Riferimento della struttura
                        ricettiva</ng-container><br>
                    <input type="file" accept=".jpg,.jpeg,.png,.bmp,.pdf,.doc,.docx"
                        (change)="onFileCirSelected($event)"><br><br>

                    <ng-container i18n="@@insert_user_file_max_size">Ogni file non deve essere più grande di 3.00
                        MB</ng-container>
                    <br>
                    <ng-container i18n="@@insert_user_file_types">Tipi ammessi sono : .jpg .jpeg .png .bmp .pdf .doc
                        .docx</ng-container>
                </td>
            </tr>

            <!-- </table> -->

            <tr>
                <td width="180px" class="text-dark" i18n="@@insert_user_dates">
                    Date permesso transito
                </td>
                <td>
                    <div id="datesDiv" class="date-wrapper">
                        <br>
                        <div id="fromDateDiv" class="date-container">
                            <p class="text-small text-dark" i18n="@@request_view_dialog_start_date">
                                Data di inizio:
                            </p>
                            <input id="from-datepicker-input" [readonly]=true [matDatepicker]="fromDatepicker"
                                value="{{ startDate }}" [formControl]="fromFormControl">
                            <mat-datepicker-toggle matSuffix [for]="fromDatepicker"></mat-datepicker-toggle>
                            <mat-datepicker #fromDatepicker></mat-datepicker>
                        </div>

                        <div id="toDateDiv" class="date-container">
                            <p class="text-small text-dark" i18n="@@request_view_dialog_expiration_date">
                                Data di fine:
                            </p>
                            <input id="to-datepicker-input" [readonly]=true [matDatepicker]="toDatepicker"
                                value="{{ expirationDate  }}" [formControl]="toFormControl">
                            <mat-datepicker-toggle matSuffix [for]="toDatepicker"></mat-datepicker-toggle>
                            <mat-datepicker #toDatepicker></mat-datepicker>
                        </div>
                        <br>
                    </div>
                </td>
            </tr>
            <!-- <table class="simple-table user-add-table"> -->
            <tr>
                <td width="180px" class="text-dark" i18n="@@insert_user_notes">Note</td>
                <td>
                    <input id="notes-input" formControlName="notes" [(ngModel)]="notes" />
                </td>
            </tr>
        </table>


        <br>
        <br>

        <a (click)="createRequest()" class="button user-add-button">
            <ng-container i18n="@@insert_user_create_user">Crea abbonamento</ng-container>
            <span>
                <fa-icon icon="paper-plane"></fa-icon>
            </span>
        </a>

        <p class="text-small text-error margin-top-10 display-inline" *ngIf="wrongPhoneNumberError"
            i18n="@@insert_user_phoneNumberError">
            Numero di telefono non valido </p>

        <p class="text-small text-error margin-top-10 display-inline" *ngIf="firstnameError"
            i18n="@@insert_user_firstnameError">
            Inserire un nome valido </p>

        <p class="text-small text-error margin-top-10 display-inline" *ngIf="lastnameError"
            i18n="@@insert_user_lastnameError">
            Inserire un cognome valido </p>

        <p class="text-small text-error margin-top-10 display-inline" *ngIf="emailError"
            i18n="@@insert_user_emailError">
            Inserire un indirizzo email valido </p>

        <p class="text-small text-error margin-top-10 display-inline" *ngIf="licencePlateError"
            i18n="@@insert_user_licencePlateError">
            La targa inserita non è valida </p>

        <p class="text-small text-error margin-top-10 display-inline" *ngIf="notesError"
            i18n="@@insert_user_notesError">
            Le note inserite non sono valide</p>

        <p class="text-small text-error margin-top-10 display-inline" *ngIf="missingFileError"
            i18n="@@insert_user_missingFileError">
            È necessario caricare tutti i file richiesti</p>

        <p class="text-small text-error margin-top-10 display-inline" *ngIf="invalidDatesError"
            i18n="@@insert_user_invalid_dates">Le date inserite non sono valide</p>

        <p class="text-small text-error margin-top-10 display-inline" *ngIf="datesTooFarError"
            i18n="@@insert_user_over_2100">La data di scadenza non deve superare l'anno 2100</p>
    </form>

</div>

<app-loading-screen #insertUserLoader [showtext]="false"></app-loading-screen>